const SET_CITIES = "SET_CITIES";
const SET_USER_CITIES = "SET_USER_CITIES";
const CLEAR_CITIES = "LOGOUT_USER";

const initialState = {
  cities: null,
  userCities:null

};

export const Cities=(state = initialState, action)=> {
  switch (action.type) {
    case SET_CITIES:
      return {
        ...state,
        cities: action.payload,
      };
          case SET_USER_CITIES:
      return {
        ...state,
        userCities: action.payload,
      };
    case CLEAR_CITIES:
      return {
        ...state,
        cities: null,
  userCities:null

      };

    default:
      return state;
  }
}
